import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus, UserCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const FollowButton = ({ sellerId, signedIn }) => {
  const navigate = useNavigate();
  const [state, setState] = useState(null); // {following, is_me}
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!signedIn) { setState({ following: false, is_me: false }); return; }
    api.get(`/sellers/${sellerId}/follow`).then((r) => setState(r.data)).catch(() => setState(null));
  }, [sellerId, signedIn]);

  if (!state || state.is_me) return null;

  const toggle = async () => {
    if (!signedIn) { navigate(`/login?next=/seller/${sellerId}`); return; }
    setBusy(true);
    try {
      const r = state.following ? await api.delete(`/sellers/${sellerId}/follow`) : await api.post(`/sellers/${sellerId}/follow`);
      setState((s) => ({ ...s, following: r.data.following }));
      if (r.data.following) toast.success("Following — you'll be notified about new notes");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update follow");
    } finally {
      setBusy(false);
    }
  };

  const on = state.following;
  return (
    <button type="button" onClick={toggle} disabled={busy} data-testid="seller-follow-btn" aria-pressed={on}
      className={`h-9 shrink-0 rounded-full px-4 text-sm font-medium flex items-center gap-1.5 transition-colors disabled:opacity-60 ${
        on ? "bg-[#1E1E1E] border border-[#27272A] text-[#D1D5DB] hover:border-[#EF4444]/50" : "bg-[#2563EB] hover:bg-[#1D4ED8] text-white"}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : on ? <UserCheck className="h-4 w-4" /> : <UserPlus className="h-4 w-4" />}
      {on ? "Following" : "Follow"}
    </button>
  );
};
